'use strict';

var _regeneratorRuntime = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread");

var _awaitAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("C:\\Users\\jamie\\Desktop\\Thesis\\planetGit\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncIterator");

var CID = require('cids');

var toCamel = require('./lib/object-to-camel');

var configure = require('./lib/configure');

var multipartRequest = require('./lib/multipart-request');

var toUrlSearchParams = require('./lib/to-url-search-params');

var anySignal = require('any-signal');

var AbortController = require('abort-controller').default;

module.exports = configure(function (api) {
  // eslint-disable-next-line valid-jsdoc

  /**
   * @type {import('../../ipfs/src/core/components/add-all').AddAll<import('.').HttpOptions>}
   */
  function addAll(_x) {
    return _addAll.apply(this, arguments);
  }

  function _addAll() {
    _addAll = _wrapAsyncGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee(input) {
      var options,
          progressFn,
          controller,
          signal,
          res,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          file,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              progressFn = options.progress; // allow aborting requests on body errors

              controller = new AbortController();
              signal = anySignal([controller.signal, options.signal]);
              _context.t0 = _awaitAsyncGenerator;
              _context.t1 = api;
              _context.t2 = _objectSpread;
              _context.t3 = {
                searchParams: toUrlSearchParams(_objectSpread({
                  'stream-channels': true
                }, options, {
                  progress: Boolean(progressFn)
                })),
                timeout: options.timeout,
                signal: signal
              };
              _context.next = 10;
              return _awaitAsyncGenerator(multipartRequest(input, controller, options.headers));

            case 10:
              _context.t4 = _context.sent;
              _context.t5 = (0, _context.t2)(_context.t3, _context.t4);
              _context.t6 = _context.t1.post.call(_context.t1, 'add', _context.t5);
              _context.next = 15;
              return (0, _context.t0)(_context.t6);

            case 15:
              res = _context.sent;
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 18;
              _iterator = _asyncIterator(res.ndjson());

            case 20:
              _context.next = 22;
              return _awaitAsyncGenerator(_iterator.next());

            case 22:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 26;
              return _awaitAsyncGenerator(_step.value);

            case 26:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 39;
                break;
              }

              file = _value;
              file = toCamel(file);

              if (!(file.hash !== undefined)) {
                _context.next = 35;
                break;
              }

              _context.next = 33;
              return toCoreInterface(file);

            case 33:
              _context.next = 36;
              break;

            case 35:
              if (progressFn) {
                progressFn(file.bytes || 0);
              }

            case 36:
              _iteratorNormalCompletion = true;
              _context.next = 20;
              break;

            case 39:
              _context.next = 45;
              break;

            case 41:
              _context.prev = 41;
              _context.t7 = _context["catch"](18);
              _didIteratorError = true;
              _iteratorError = _context.t7;

            case 45:
              _context.prev = 45;
              _context.prev = 46;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 50;
                break;
              }

              _context.next = 50;
              return _awaitAsyncGenerator(_iterator.return());

            case 50:
              _context.prev = 50;

              if (!_didIteratorError) {
                _context.next = 53;
                break;
              }

              throw _iteratorError;

            case 53:
              return _context.finish(50);

            case 54:
              return _context.finish(45);

            case 55:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[18, 41, 45, 55], [46,, 50, 54]]);
    }));
    return _addAll.apply(this, arguments);
  }

  return addAll;
});
/**
 * @typedef {import('../../ipfs/src/core/components/add-all').UnixFSEntry} UnixFSEntry
 */

/**
 * @returns {UnixFSEntry}
 */

function toCoreInterface(_ref) {
  var name = _ref.name,
      hash = _ref.hash,
      size = _ref.size,
      mode = _ref.mode,
      mtime = _ref.mtime,
      mtimeNsecs = _ref.mtimeNsecs;
  var output = {
    path: name,
    cid: new CID(hash),
    size: parseInt(size)
  };

  if (mode != null) {
    output.mode = parseInt(mode, 8);
  }

  if (mtime != null) {
    output.mtime = {
      secs: mtime,
      nsecs: mtimeNsecs || 0
    };
  } // @ts-ignore


  return output;
}